import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import Button from '../Button/Button.js'
import Tabs from '../Tabs/Tabs.js'

import './Pricing.css';

import addCookieWithConsent from '../../pattern_utilities/addCookieWithConsent.js';

var pf_config = require('../../pf_config.json');

var Cookies = require('js-cookie');

class Pricing extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      pricing: Cookies.get("pricing_preference") || "monthly"
    }
  }

  render(){
    const { dispatch, user, team } = this.props; 
    const state = this.state;

    return (
      <div className="container">
        <div className="row row-no-gutter row-eq-height row-push-down">
          <div className="col-md-12 flex-center-column">
            <Tabs
              value={this.state.pricing}
              size="large"
              onChange={(e) => { 
                this.setState({pricing: e.value})
                addCookieWithConsent("pricing_preference", e.value, dispatch)
              }}
              items={[
                  {
                    display: "Pay Monthly",
                    value: "monthly"
                  },
                  {
                    display: "Pay Yearly",
                    value: "yearly"
                  },
                ]}
            />
          </div>
          <div className="col-md-4">
            <div className="col-themed col-themed-fill col-themed-shadow col-themed-hover-shadow ">
              <div className="pricing-breakout-header">
                <h3 className="text-center text-900">{pf_config.plans.open.display_name}</h3>
                <p className="lead text-center">
                  Great for side projects, students, and more.
                </p>
              </div>
              
              <div className="price-breakout">
                <div className="price-breakout-number">
                  free
                </div>
                <div className="price-breakout-description">and always will be<br/>&nbsp;<br/>&nbsp;</div>
              </div> 

              <ul className="list-divided text-small">
                <li>Import, edit, and download .PATs</li>
                <li>Library of 400+ free patterns</li>
                <li>Pattern calculators in MM & Inch</li>
                <li>Unlimited public patterns</li>
                <li>Rotate and scale patterns</li>
              </ul>


              <div className="flex-center-column">
                {
                  (user.isLoggedIn && !user.roles.pro && !user.roles.enterprise) && 
                  <strong className="text-primary" style={{position: 'relative', top: 5}}>
                    <i className="fas fa-check"/> Your Account
                  </strong>
                }
                {
                  !user.isLoggedIn && 
                  <Link to="/sign-up" className="button-link">
                    <Button
                      display="Create a Free Account"
                      size="medium"
                    />
                  </Link>
                }
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="col-themed col-themed-fill col-themed-shadow col-themed-hover-shadow ">
              <div className="pricing-breakout-header">
                <h3 className="text-center text-900">{pf_config.plans.pro.display_name}</h3>
                <p className="lead text-center">
                  For individuals creating bespoke patterns.
                </p>
              </div>

              <div className="price-breakout">
                <span className="savings-line">{this.state.pricing === "monthly" ? <span>&nbsp;</span> : <span className="text-primary">2 months free!</span>}</span>
                <div className="price-breakout-number">
                  <span className="dollar-sign">$</span>{this.state.pricing === "monthly" ? pf_config.plans.pro.price : pf_config.plans.pro.price_yearly}
                  <span className="price-breakout-description"> / {this.state.pricing === "monthly" ? "month" : "year"}</span>
                </div>
                <div className="price-breakout-description">
                  single user license<br/>
                  30 day free trial<br/>&nbsp;
                </div>
              </div>

              <ul className="list-divided text-small">
                <li>Unlimited private patterns</li>
                <li>DXF to PAT file converter</li>
                <li>High-res image exporting</li>
                <li>Draw patterns in your browser</li>
                <li>Night Mode</li>
              </ul>


              <div className="flex-center-column">
                {
                  (user.isLoggedIn && user.roles.pro && !user.roles.enterprise) && 
                  <strong className="text-primary">
                    <i className="fas fa-check"/> Your Account
                  </strong>
                }
                {
                  (user.isLoggedIn && !user.roles.pro && !user.roles.enterprise) && 
                  <Link to="/settings/my-account/upgrade-to-pro" className="button-link">
                    <Button
                      display="Upgrade to Pro"
                      size="medium"
                    />
                  </Link>
                }
                {
                  !user.isLoggedIn && 
                  <Link to={"/sign-up?after=" + window.btoa("/settings/my-account/upgrade-to-pro")} className="button-link">
                    <Button
                      display="Get Pattycake Pro"
                      size="medium"
                    />
                  </Link>
                }
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="col-themed col-themed-fill col-themed-shadow col-themed-hover-shadow ">
              {/*<div className="corner-ribbon corner-ribbon-top-right">
                $2 per user
              </div>*/}
              <div className="pricing-breakout-header">
                <h3 className="text-center text-900">{pf_config.plans.teams.display_name}</h3>
                <p className="lead text-center">
                  Flexible collaboration for just $2 per seat.
                </p>
              </div>

              <div className="price-breakout">
                <span className="savings-line">{this.state.pricing === "monthly" ? <span>&nbsp;</span> : <span className="text-primary">2 months free!</span>}</span>
                <div className="price-breakout-number">
                  <span className="dollar-sign">$</span>{this.state.pricing === "monthly" ? pf_config.plans.teams.price : pf_config.plans.teams.price_yearly}
                  <span className="price-breakout-description"> / {this.state.pricing === "monthly" ? "month" : "year"}</span>
                </div>
                <div className="price-breakout-description">
                  per 5 user license<br/>
                  30 day free trial<br/>&nbsp;
                </div>
              </div>

              <ul className="list-divided text-small">
                <li>Collaborate across your company</li>
                <li>Add or remove members anytime</li>
                <li>Expandable as your firm grows</li>
                <li>Organize patterns by projects</li>
                <li>Custom signatures and themes</li>
              </ul>

              <div className="flex-center-column">
                 {
                  !user.isLoggedIn && 
                  <Link to={"/sign-up?after=" + window.btoa("pattycake-for-forms-sign-up") + "&in=" + window.btoa("Pattycake for Firms") + "&tg=" + window.btoa("Let's get you setup.")} className="button-link">
                    <Button
                      display="Setup Your Firm"
                      color="success"
                      size="medium"
                    />
                  </Link>
                }
                {
                  (user.isLoggedIn && !user.roles.enterprise) && 
                  <Link to="/pattycake-for-firms-sign-up" className="button-link">
                    <Button
                      display={team.hasTeams ? "Create Another" : "Setup Your Firm"}
                      color="success"
                      size="medium"
                    />
                  </Link>
                }
              </div>
            </div>
          </div>

         {/* <div className="col-md-3">
            <div className="col-themed col-themed-fill col-themed-shadow col-themed-hover-shadow ">
              <div className="pricing-breakout-header">
                <h3 className="text-center text-900">{pf_config.plans.enterprise.display_name}</h3>
                <p className="lead text-center">
                  No licenses to manage & automatic access.
                </p>
              </div>

              <div className="price-breakout">
                <span className="savings-line">{this.state.pricing === "monthly" ? <span>&nbsp;</span> : <span className="text-primary">2 months free!</span>}</span>
                <div className="price-breakout-number">
                  <span className="dollar-sign">$</span>{this.state.pricing === "monthly" ? pf_config.plans.enterprise.price : pf_config.plans.enterprise.price_yearly}
                  <span className="price-breakout-description"> / {this.state.pricing === "monthly" ? "month" : "year"}</span>
                </div>
                <div className="price-breakout-description">
                  company-wide license<br/>
                  30 day free trial<br/>&nbsp;
                </div>
              </div>

              <ul className="list-divided text-small">
                <li>Automatic joining for employees</li>
                <li>Organize patterns by office</li>
                <li>Custom signatures and themes</li>
                <li>One price for your entire org</li>
                <li>Simplified billing and management</li>
              </ul>

              <div className="flex-center-column">
                {
                  !user.isLoggedIn && 
                  <Link to={"/sign-up?after=" + window.btoa("pattycake-enterprise-sign-up") + "&in=" + window.btoa("Pattycake Enterprise") + "&tg=" + window.btoa("First, create a free account:")} className="button-link">
                    <Button
                      display="Get Started"
                      color="primary"
                      size="medium"
                    />
                  </Link>
                }
                {
                  (user.isLoggedIn  && !user.roles.enterprise) && 
                  <Link to="/pattycake-enterprise-sign-up" className="button-link">
                    <Button
                      display="Get Started"
                      color="primary"
                      size="medium"
                    />
                  </Link>
                }
                {
                  (user.roles.enterprise) && 
                  <strong className="text-primary">
                    <i className="fas fa-check"/> Your Account
                  </strong>
                }
              </div>
            </div>
          </div>*/}
        </div>
        <div className="row justify-content-center row-push-down-extra">
          <div className="col-md-4 text-center">
            <p className="lead"> 
              Unsure which is right for  you?
            </p>
            <Link to="/feature-table" className="button-link">
              <Button
                display="Compare Features"
                color="grey"
                size="medium"
              />
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  const { user, team } = state;

  return {
    user, team
  }
}

export default connect(mapStateToProps)(Pricing);



// WEBPACK FOOTER //
// ./src/components/Pricing/Pricing.js